import React, { useEffect, useRef, useState } from "react";

import styles from "../../styles/AccountModals.module.css";
import { BASE_URL } from "../../utils/constants";
import axios from "axios";
import toast from "react-hot-toast";
import Spinner from "../../components/spinner";
import { handleApiError } from "../../utils/handleApiError";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../components/ui/dialog";
import Button from "../../components/button-v1";
import AlertDialog from "../../components/alert-dialogue";
export const ActiveLocation = ({
  isOpen,
  onClose,
  location_info,
  comp_renderer,
  current_render,
}) => {
  const modalRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  // const handleCheckBoxChange = (e) => {
  //     const { name, checked } = e.target;
  //     setFormData((prev) => ({ ...prev, [name]: checked }));
  // };

  const activeLocation = async () => {
    const token = localStorage.getItem("authToken");
    const account_id = sessionStorage.getItem("acc_id");
    const url = `${BASE_URL}/accounts/${account_id}/locations/${location_info.id}/`;

    try {
      const response = await axios.patch(
        url,
        { active: true },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLoading(false);
      comp_renderer(!current_render);
      onClose();
      toast.success("Location activated Successfully");
    } catch (error) {
      handleApiError(error);
      setLoading(false);
    }
  };

  const fetchLocationList = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const account_id = sessionStorage.getItem("acc_id");
      const current_location = JSON.parse(sessionStorage.getItem("current_loc"));
      const url = `${BASE_URL}/accounts/${account_id}/locations/?status=active`;

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      sessionStorage.setItem("loc_list", JSON.stringify(response.data.locations));
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await activeLocation();
    await fetchLocationList();

    const locations = JSON.parse(sessionStorage.getItem("loc_list"));

    if (locations.length === 1) {
      localStorage.setItem("fallback_location", JSON.stringify(locations[0]));
      sessionStorage.setItem("current_loc", JSON.stringify(locations[0]));
    }
  };

  if (!isOpen) return null;

  return (
    <AlertDialog
      open={isOpen}
      setOpen={onClose}
      title="Activate Location"
      description={`Are you sure you want to activate ${location_info?.name}`}
    >
      <Button variant="normal" size="default" onClick={onClose}>
        Cancel
      </Button>
      <Button loading={loading} onClick={handleSubmit}>
        Activate
      </Button>
    </AlertDialog>
  );
};

export const DeleteLocation = ({
  isOpen,
  onClose,
  location_info,
  comp_renderer,
  current_render,
}) => {
  const modalRef = useRef(null);
  const [loading, setLoading] = useState(false);
  // const [formData, setFormData] = useState({
  //     name: location_info.name,
  //     address_line_1: location_info.address_line_1,
  //     address_line_2: location_info.address_line_2,
  //     city: location_info.city,
  //     state: location_info.state,
  //     postal_code: location_info.postal_code,
  //     timezone: location_info.timezone,
  //     // active: location_info.active
  // });

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  // const handleCheckBoxChange = (e) => {
  //     const { name, checked } = e.target;
  //     setFormData((prev) => ({ ...prev, [name]: checked }));
  // };

  const deactiveLocation = async () => {
    const token = localStorage.getItem("authToken");
    const account_id = sessionStorage.getItem("acc_id");
    const url = `${BASE_URL}/accounts/${account_id}/locations/${location_info.id}/`;

    try {
      // setLoading(true)
      const response = await axios.patch(
        url,
        { active: false },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLoading(false);
      comp_renderer(!current_render);
      onClose();
      toast.success("Location deleted Successfully");
    } catch (error) {
      handleApiError(error);
      setLoading(false);
    }
  };

  const fetchLocationList = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const account_id = sessionStorage.getItem("acc_id");
      const current_location = JSON.parse(sessionStorage.getItem("current_loc"));
      const url = `${BASE_URL}/accounts/${account_id}/locations/?status=active`;

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      sessionStorage.setItem("loc_list", JSON.stringify(response.data.locations));

      if (current_location.id === location_info.id) {
        sessionStorage.setItem(
          "current_loc",
          JSON.stringify(response.data.locations[0] || {})
        );
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await deactiveLocation();
    await fetchLocationList();
  };

  if (!isOpen) return null;

  return (
    <AlertDialog
      open={isOpen}
      setOpen={onClose}
      title="Delete Location"
      description={`Are you sure you want to delete ${location_info?.name}`}
    >
      <Button variant="normal" size="default" onClick={onClose}>
        Cancel
      </Button>
      <Button
        loading={loading}
        variant="danger"
        size="default"
        onClick={handleSubmit}
      >
        Delete
      </Button>
    </AlertDialog>
  );
};

const EditLocationModal = ({
  isOpen,
  onClose,
  location_info,
  comp_renderer,
  current_render,
}) => {
  const modalRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: location_info.name,
    address_line_1: location_info.address_line_1,
    address_line_2: location_info.address_line_2,
    city: location_info.city,
    state: location_info.state,
    postal_code: location_info.postal_code,
    timezone: location_info.timezone,
    // active: location_info.active
  });

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  // const handleCheckBoxChange = (e) => {
  //     const { name, checked } = e.target;
  //     setFormData((prev) => ({ ...prev, [name]: checked }));
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const editLocationinfo = async () => {
    const token = localStorage.getItem("authToken");
    const account_id = sessionStorage.getItem("acc_id");
    const url = `${BASE_URL}/accounts/${account_id}/locations/${location_info.id}/`;

    try {
      // setLoading(true)
      const response = await axios.patch(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setLoading(false);
      comp_renderer(!current_render);
      onClose();
      toast.success("Location updated Successfully");
    } catch (error) {
      handleApiError(error);
    }
  };

  const validateForm = () => {
    let errors = [];

    if (!formData.name?.trim()) errors.push("Name is required.");
    if (!formData.timezone?.trim()) errors.push("Timezone is required.");
    if (!formData.postal_code?.trim()) errors.push("Postal Code is required.");

    if (errors.length > 0) {
      toast.error(errors.join("\n"), {
        autoClose: 5000,
        style: {
          whiteSpace: "pre-line",
          textAlign: "left",
        },
      });
      return false;
    }

    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      editLocationinfo();
    }
  };

  const states = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];

  const timeZones = [
    { label: "Pacific Time (US & Canada)", value: "America/Los_Angeles" },
    { label: "Mountain Time (US & Canada)", value: "America/Denver" },
    { label: "Central Time (US & Canada)", value: "America/Chicago" },
    { label: "Eastern Time (US & Canada)", value: "America/New_York" },
    { label: "UTC", value: "UTC" },
  ];

  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} setOpen={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Location</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <form
            className={`${styles.comp_wrapper} ${loading ? styles.loading : ""
              }`}
          >
            <div className={styles.input_group}>
              <div className={styles.input_field}>
                <label>Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Location Name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>

              <div className={styles.input_field}>
                <label>TimeZone</label>
                <select
                  name="timezone"
                  value={formData.timezone}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select Timezone
                  </option>
                  {timeZones.map((timezone, index) => (
                    <option key={index} value={timezone.value}>
                      {timezone.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className={styles.input_group}>
              <div className={styles.input_field}>
                <label>Address Line 1</label>
                <input
                  type="text"
                  name="address_line_1"
                  placeholder="Address Line 1"
                  value={formData.address_line_1}
                  onChange={handleChange}
                />
              </div>

              <div className={styles.input_field}>
                <label>Address Line 2</label>
                <input
                  type="text"
                  name="address_line_2"
                  placeholder="Address Line 2"
                  value={formData.address_line_2}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className={styles.input_group}>
              <div className={styles.input_field}>
                <label>city</label>
                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  value={formData.city}
                  onChange={handleChange}
                />
              </div>

              <div className={styles.input_field}>
                <label>State</label>
                <select
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select a state
                  </option>
                  {states.map((state, index) => (
                    <option key={index} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className={`${styles.input_group} ${styles.postal_code}`}>
              <div className={styles.input_field}>
                <label>Postal Code</label>
                <input
                  type="number"
                  name="postal_code"
                  placeholder="Postal Code"
                  value={formData.postal_code}
                  onChange={handleChange}
                  className="no-arrows"
                />
              </div>
            </div>

            {/* <div className={`${styles.input_group} ${styles.checkbox_container}`}>
                        <div className={styles.input_field}>
                            <label className={styles.checkbox_wrapper}>
                                <input type="checkbox" name="active" checked={formData.active} onChange={handleCheckBoxChange} />
                                Active
                            </label>
                        </div>
                    </div> */}
          </form>
        </DialogBody>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} loading={loading}>
            Update
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EditLocationModal;
